import React from "react";
import { Card, CardBody } from "reactstrap";
import CountUp from "react-countup";
import {  Spin } from "antd";
const CardItemS = ({ title, icon, counterEnd, currency, isLoading, isError, error,customValue }) => {
  <CountUp
  start={0}
  end={counterEnd || 0}
  duration={3}
  formattingFn={(value) => value.toString()}
/>
  return (
    <Card className="card-animate " style={{ borderRadius: "10px",background:"#FFFFFF",border:'none' }}>
      <CardBody>
        <div className="d-flex flex-column align-items-start">
         <div
            style={{
              fontWeight: "400",
              fontSize: "15px",
              fontFamily: "Poppins",
              color: "#000000CC",
              width: "100%"
            }}
          >
            {title || "-"}
          </div>
          <div className="d-flex justify-content-start flex-grow-1">
            <h2
              className="text-start mt-0 fs-3 fs-md-2 fs-lg-1"
              style={{ color: "#121212", fontFamily: "Helvetica Neue, sans-serif"}}
            >
              
              <span className="d-flex align-items-baseline counter-value" style={{ gap: "6px" }}>
                {isLoading ? (
                    <Spin size="small" />
                  ) : isError ? (
                    <span style={{ color: "red", fontSize: 16 }}>
                      {error || "Erreur"}
                    </span>
                  ) : customValue ? (
                    <span style={{ fontWeight: '500', fontSize: '24px', fontFamily: 'Poppins', color: '#000000' }}>
                      {customValue}
                    </span>
                  ) : (
                    <>
                      <CountUp start={0} end={counterEnd || 0} duration={3} separator=" " />
                      <span>{currency || ""}</span>
                    </>
                  )}

              </span>
            </h2>
          </div>
          <div className="d-flex flex-column align-items-start">
          </div>
              <div className="avatar-sm flex-shrink-0 mb-2 d-flex justify-content-between align-items-center w-100">
                <span style={{fontWeight:'400',fontSize:"13px",fontFamily:"Poppins",color:"#0000004D",marginTop:'30px'}}></span>
               <img src={icon}style={{width:97,height:52}} alt="Icon" />
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
export default CardItemS;
